import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { BarChart3 } from 'lucide-react';

const AttendanceAnalytics = () => {
  return (
    <div className="space-y-6">
      <Card>
        <CardContent className="p-6">
          <div className="text-center">
            <BarChart3 className="w-16 h-16 mx-auto mb-4 text-gray-400" />
            <h2 className="text-xl font-semibold mb-2">Attendance Analytics</h2>
            <p className="text-gray-600">Attendance analytics coming soon...</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AttendanceAnalytics;
